module.exports = __webpack_public_path__ + "static/painting - 3-6c7d42dfe5a54a2bd085a3453ec50c2b.jpg";